import * as React from 'react';
import {ActivationActionProps, ActivationForm} from '../../components/ActivationForm/ActivationForm';
import {ActivationSuccess} from '../../components/ActivationSuccess/ActivationSuccess';
import {ErrorPage} from '../../components/ErrorPage/ErrorPage';
import {AccountDetailContext, AccountDetailKeeper, AccountDetailKeeperState} from '../../contexts/AccountDetailKeeper';
import {AccountProps, CurrentUser} from '../../contexts/SettingsKeeper';
import {polyglot} from '../../helpers/Polyglot';
import {LocalesKeys} from '../../localesKeys';

export interface ActivationProps {
    currentUser: CurrentUser;
    accounts: AccountProps[];
}

export const Activation = ({currentUser, accounts}: ActivationProps) => {
    const getContent = (currentAccountKey, activationStatus, { ...accountDetailsProps }: ActivationActionProps) => {
        if (activationStatus === 'success') {
            return (<ActivationSuccess currentAccountKey={currentAccountKey} joinMode={!accountDetailsProps.hasLicense || !accountDetailsProps.seatAvailable}/>);
        } else if (!accountDetailsProps.userHasAccess) {
            return (<ErrorPage errorTitle={polyglot.t(LocalesKeys.activationErrorTitle)} errorMessage={polyglot.t(LocalesKeys.activationErrorMessage)}/>);
        }
        return(<ActivationForm accounts={accounts}
                               currentAccountKey={currentAccountKey}
                               activationStatus={activationStatus}
                               {...accountDetailsProps}
        />);
    };

    return (
            <AccountDetailKeeper accounts={accounts} currentUser={currentUser}>
                <AccountDetailContext.Consumer>
                    {
                        ({ currentAccountKey, activationStatus, ...otherProps }: AccountDetailKeeperState) => (
                            <>
                            {getContent(currentAccountKey, activationStatus, otherProps)}
                            </>
                        )
                    }
                </AccountDetailContext.Consumer>
            </AccountDetailKeeper>
        );

};
